import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type BriefSet from "./BriefSet";
import type Organisation from "./Organisation";
import type OrganisationBrand from "./OrganisationBrand";
import type User from "./User";

@Model()
class OrganisationTeam extends ApplicationRecord {
  static jsonapiType = "organisation_teams";

  @BelongsTo() brandProfile: OrganisationBrand;

  @Attr() brandProfileId: number;

  @Attr() briefSetIds: number[];

  @HasMany() briefSets: BriefSet[];

  @Attr() color: string;

  @Attr() logoData: string;

  @Attr({ persist: false }) logoUrl: string;

  @Attr() name: string;

  @Attr() operationalTeam: boolean;

  @Attr() operationalTeamUserIds: number[];

  @HasMany() operationalTeamUsers: User[];

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() primaryStreamId: number;

  @HasMany() primaryUsers: User[];

  @Attr() roleId: number;

  @Attr() secondaryUserIds: number[];

  @HasMany() secondaryUsers: User[];

  @Attr() secondaryUsersCount: number;

  @Attr() teamRegion: string;

  @Attr() userIds: number[];

  @HasMany() users: User[];

  @Attr() usersCount: number;
}

export default OrganisationTeam;
